<div class="flex--column">
  <agr-summary-card
    [title]="'sustainability.farm-resources-title' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="true"
    class="spacing--margin-all"
  >
    <ng-container customActions>
      <button mat-flat-button color="primary" (click)="openResourceSlideIn()">
        <mat-icon>add</mat-icon>{{ 'sustainability.add-farm-resources' | translate }}
      </button>
    </ng-container>
    <agr-table [config]="tableConfigFarmResource" [emptyTitle]="" [emptyDescription]=""></agr-table>
  </agr-summary-card>
</div>

<div class="flex--column">
  <agr-summary-card
    [title]="'sustainability.cycle-resources' | translate"
    [canExpand]="false"
    [isExpanded]="true"
    class="spacing--margin-all"
  >
    <agr-table
      [config]="tableConfigCycleResource"
      [emptyTitle]=""
      [emptyDescription]=""
    ></agr-table>
  </agr-summary-card>
</div>

<agr-notification-empty [isEmpty]="false" emptyImage="assets/images/arrival.jpg">
</agr-notification-empty>
